import * as React from 'react';

const MetamaskIcon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5C16",
        d: "m17.82 18.08-3.88-1.15-2.92 1.75H8.98l-2.93-1.75-3.87 1.15L1 14.1 2.18 9.7 1 5.95l1.18-4.63 6.05 3.62h3.54l6.05-3.62L19 5.95 17.82 9.7 19 14.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5C16",
        d: "m2.18 1.32 6.06 3.62-.25 2.49zM6.06 14.1l2.66 2.03-2.66.8zM8.5 10.75 8 7.43 4.71 9.69V12l1.33-1.26zM17.82 1.32l-6.05 3.62.24 2.49zM13.95 14.1l-2.67 2.03 2.67.8zM15.29 9.69 12 7.43l-.52 3.32h2.46L15.28 12z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E34807",
        d: "m6.05 16.93-3.87 1.15L1 14.1h5.05zM8.5 10.75l.75 4.8-1.03-2.67-3.5-.87 1.33-1.26zM13.95 16.93l3.87 1.15L19 14.1h-5.05zM11.5 10.75l-.75 4.8 1.03-2.67 3.5-.87-1.33-1.26z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF8D5D",
        d: "M1 14.1 2.18 9.7H4.7L4.72 12l3.5.87 1.03 2.66-.53.6-2.67-2.04zM19 14.1 17.82 9.7H15.3L15.28 12l-3.5.87-1.03 2.66.53.6 2.67-2.04z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF8D5D",
        d: "M11.77 4.94H8.23L8 7.43l1.26 8.11h1.5l1.26-8.11z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#661800",
        d: "M2.18 1.32 1 5.95 2.18 9.7H4.7L8 7.43zM7.77 11.71H6.62l-.62.61 2.22.56zM17.82 1.32 19 5.95 17.82 9.7H15.3L12 7.43zM12.23 11.71h1.15l.62.62-2.22.55zM11.02 17.1l.26-.97-.53-.58h-1.5l-.53.58.26.96"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C0C4CD",
        d: "M11.02 17.1v1.58H8.98v-1.59z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E7EBF6",
        d: "m6.06 16.93 2.92 1.75v-1.59l-.26-.96zM13.95 16.93l-2.93 1.75v-1.59l.26-.96z"
    }));

export { MetamaskIcon };
//# sourceMappingURL=Metamask.mjs.map
